export class ProTasksRoutePrice {

  constructor(public totalPrice: number,
              public fuelPrice: number,
              public operatingCost: number,
              public roadsTolls: number,
              public markedRoadsTolls: number) {
  }

}
